import {Component, React, observer} from '$src/handy'
import * as css from './AlertBanner.css'
import AlertIcon from 'react-icons/lib/fa/exclamation-triangle'

@observer
export default class Header extends Component<{}, {}> {
  render() {
    const {notifications} = this.store
    const alerts = notifications.status === 'Loaded' ? notifications.getAlert() : []

    return alerts.length > 0 && (
      <div className={css.container}>
        {alerts.map((n, i) => (
          <div className={css.wrapper} key={i}>
            <AlertIcon style={{ height: '22px', width: '22px' }} />
            <div className={css.content}>
              {n.content.map(str => <p>{str}</p>)}
            </div>
          </div>
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/PageLayout/AlertBanner.tsx